import {
  CLIENT_SHOPPING_CART_API,
  CLIENT_SHOPPING_CART_CLEAR_API,
  CLIENT_SHOPPING_CART_ITEMS_API,
  CLIENT_SHOPPING_CART_REMOVE_ITEM_API,
  CLIENT_SHOPPING_CART_RESTORE_API,
  CLIENT_SHOPPING_CART_SELECTED_BRANCH_API,
} from "shared/constants/api-endpoint";
import { apiClient } from "shared/plugins/http-service";
import {
  IAddUpdateShoppingCartItemModel,
  IRemovedShoppingCartItemModel,
  IRestoreShoppingCartModel,
  ShoppingCartApiModel,
} from "./shopping-cart.models";
export const getShoppingCartAPI = async () => {
  return await apiClient.getHttp<ShoppingCartApiModel>(
    `${CLIENT_SHOPPING_CART_API}`
  );
};

export const selectedBranchShoppingCartAPI = async (branchId: number) => {
  return await apiClient.postHttp<ShoppingCartApiModel>(
    `${CLIENT_SHOPPING_CART_SELECTED_BRANCH_API}`,
    null,
    {
      params: {
        branchId: branchId,
      },
    }
  );
};

export const clearShoppingCartAPI = async () => {
  return await apiClient.postHttp(`${CLIENT_SHOPPING_CART_CLEAR_API}`);
};

export const addItemShoppingCartAPI = async (
  model: IAddUpdateShoppingCartItemModel
) => {
  return await apiClient.postHttp<ShoppingCartApiModel>(
    `${CLIENT_SHOPPING_CART_ITEMS_API}`,
    model
  );
};

export const updateItemShoppingCartAPI = async (
  model: IAddUpdateShoppingCartItemModel
) => {
  return await apiClient.putHttp<ShoppingCartApiModel>(
    `${CLIENT_SHOPPING_CART_ITEMS_API}`,
    model
  );
};

export const restoreShoppingCartAPI = async (
  model: IRestoreShoppingCartModel
) => {
  return await apiClient.postHttp<ShoppingCartApiModel>(
    `${CLIENT_SHOPPING_CART_RESTORE_API}`,
    model
  );
};

export const removedItemShoppingCartAPI = async (
  model: IRemovedShoppingCartItemModel
) => {
  return await apiClient.postHttp<ShoppingCartApiModel>(
    `${CLIENT_SHOPPING_CART_REMOVE_ITEM_API}`,
    model
  );
};
